const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/dashboard/default',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    backendApi: "https://api.kl36.bet",
    socketApi: "https://api.kl36.bet"
     // backendApi: "https://dev.ssmain-mbet.com/devapi/api"
};

export default config;
